/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {}
 */
export interface SchemaSearchRequest {
    /** The filter to apply to the search. */
    filter?: Truvity.SchemaFilter[];
    /** The sort order to apply to the search. */
    sort?: Truvity.SchemaSort[];
}
